var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Perfil",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarPerfis();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterPerfil();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listPerfis,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.situacao
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarPerfil(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterPerfil(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Excluir',
            "icon": 'mdi-delete',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.excluirPerfil(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.situacao ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.situacao ? 'var(--primary-button-color)' : 'silver'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarPerfil(item);
            }
          }
        })];
      }
    }, {
      key: `item.emUso`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Detalhar Uso',
            "icon": item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
            "color": item.emUso ? 'green' : 'red',
            "small": true,
            "disabled": !item.emUso
          },
          on: {
            "click": function ($event) {
              item.emUso ? _vm.openDialogDetalharUsoPerfil(item) : null;
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarPerfilDialog', {
    attrs: {
      "visible": _vm.dialogManterPerfil.visible,
      "content": _vm.dialogManterPerfil.content,
      "edit": _vm.dialogManterPerfil.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterPerfil.close();
      },
      "onSave": function ($event) {
        return _vm.buscarPerfis();
      }
    }
  }), _c('VisualizarPerfilDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarPerfil.visible,
      "content": _vm.dialogVisualizarPerfil.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarPerfil.close();
      }
    }
  }), _c('DetalharUsoPerfilDialog', {
    attrs: {
      "visible": _vm.dialogDetalharUsoPerfil.visible,
      "content": _vm.dialogDetalharUsoPerfil.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogDetalharUsoPerfil.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }